import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import { PromptDialog } from './PromptDialog';
import { AIMenuItem } from './AIMenuItem';
import { EditOrGenerateMenuItem } from './EditOrGenerateMenuItem';
import { useTranslation } from 'react-i18next';

type AIMenuContentProps = {
  promptDialogOpen: boolean;
  prompt: string;
  onPromptChange: (value: string) => void;
  onClosePromptDialog: () => void;
  onGenerateWithPrompt: () => void;
  hasTextSelected: boolean;
  aiCustomEditorPromptEnabled: boolean;
  onFixGrammar: () => void;
  onSimplifyText: () => void;
  onCompleteSentence: () => void;
  onOpenPromptDialog: () => void;
};

export const AIMenuContent = ({
  promptDialogOpen,
  prompt,
  onPromptChange,
  onClosePromptDialog,
  onGenerateWithPrompt,
  hasTextSelected,
  aiCustomEditorPromptEnabled,
  onFixGrammar,
  onSimplifyText,
  onCompleteSentence,
  onOpenPromptDialog,
}: AIMenuContentProps) => {
  const { t } = useTranslation();

  if (promptDialogOpen) {
    return (
      <PromptDialog
        prompt={prompt}
        onPromptChange={onPromptChange}
        onCancel={onClosePromptDialog}
        onSubmit={onGenerateWithPrompt}
        placeholder={t('editor.toolbar.ai.prompt_placeholder')}
        cancelLabel={t('cancel')}
        submitLabel={t('submit')}
      />
    );
  }

  if (!hasTextSelected && aiCustomEditorPromptEnabled) {
    return (
      <EditOrGenerateMenuItem
        enabled={aiCustomEditorPromptEnabled}
        withDivider={false}
        onClick={onOpenPromptDialog}
        label={t('editor.toolbar.ai.edit_or_generate')}
      />
    );
  }

  return (
    <>
      <EditOrGenerateMenuItem
        enabled={aiCustomEditorPromptEnabled}
        withDivider={true}
        onClick={onOpenPromptDialog}
        label={t('editor.toolbar.ai.edit_or_generate')}
      />
      <AIMenuItem
        testId="fix-grammar-menu-item"
        onClick={onFixGrammar}
        icon={SpellcheckIcon}
        label={t('editor.toolbar.ai.fix_grammar_spelling')}
      />
      <AIMenuItem
        testId="simplify-text-menu-item"
        onClick={onSimplifyText}
        icon={AutoAwesomeIcon}
        label={t('editor.toolbar.ai.simplify_text')}
      />
      <AIMenuItem
        testId="complete-sentence-menu-item"
        onClick={onCompleteSentence}
        icon={KeyboardTabIcon}
        label={t('editor.toolbar.ai.complete_sentence')}
        shortcut="Shift +tab"
      />
    </>
  );
};
